<template>
    <basic-header
        pretitle="Administration"
        title="Documentation Links"
        buttonText="Add Documentation Link"
        @btnClick="showModal({ component: 'addDocLink' })"
    />

    <div class="container-fluid">
        <div class="card">
            <datatable
                tableId="docLinksTable"
                :columns="columns"
                uniqueField="id"
                :data="$store.state.admin.docLinks"
                @deleteRows="showDeleteDocLinks"
                :deletable="true"
                :compact="true"
                :selectCheckboxes="true"
                :detailColumn="{baseUrl:'documentations/', name: 'Documentation', identifier:'id'}"
            />
        </div>
    </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import Datatable from "../../components/Datatable.vue";
import { secondsTohms } from "../../utils/commonFunction";
import { mapActions } from "vuex";

export default {
    name: "DocLinks",
    components: { BasicHeader, Datatable },
    data() {
        return {
            columns: [
                { data: "title" },
                { data: "route_name", title: "Route Name" },
                { data: "route_path", title: "Route Path" },
                { 
                    data: "url",
                    render: function (data, type, row) {
                        if (!data) return "";
                        return `<a href="${data}" target="_blank" class="text-decoration-none">${data}</a>`;
                    },
                }
            ],
        };
    },
    beforeMount() {
        this.$store.dispatch("admin/fetchDocLinks");
    },
    methods: {
        showDeleteDocLinks(rows) {
            this.showModal({ component: "deleteDocLinks", data: rows });
        },
        ...mapActions({
            showModal: "showModal",
        }),
    },
};
</script>

<style scoped>
</style> 